<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<div class="page-container card col-md-8">
						<ThePageHeader></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<TabView class="p-1">
								<TabPanel>
									<template #header>
										<i class="pi pi-fw pi-shield"></i>
										<span>2FA</span>
									</template>
						
									<TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>
						
									<div class="row" v-if="!isPageLoading">
										<div class="col-md-12 p-4 pb-0">
											<div v-for="(setting, index) in settings" :key="index">
												<div class="row mb-3" v-if="!setting.isClosed && setting.propertyName.startsWith('1_')">
													<div class="mb-1" v-if="setting.propertyLabel.indexOf('|') != -1">
														<Divider align="left">
															<span class="p-tag">{{setting.propertyLabel.substring(0, setting.propertyLabel.indexOf('|'))}}</span>
														</Divider>
													</div>
													
													<div class="col-md-3" :class="{'required' : (setting.propertyName.indexOf('_M_') != -1)}">
														<label class="col-form-label-title">{{setting.propertyLabel.substring(setting.propertyLabel.indexOf('|') + 1)}}:</label>
														
														<InputText class="p-inputtext" type="hidden" v-model="setting.sequence" :value="setting.sequence = index + 1" />
													</div>
														
													<div class="col-md-6" v-if="setting.propertyName.endsWith('_B')">
														<InputSwitch v-model="setting.propertyValue" />
													</div>
													
													<div class="col-md-6" v-else>
														<InputText class="p-inputtext" type="text" maxlength="255" placeholder="Value" v-model="setting.propertyValue" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</TabPanel>
							</TabView>
							
							<div class="row" v-if="!isPageLoading">
								<div class="col-md-12 p-4 pt-0">
									<div class="row mb-3">
										<div class="col-md-3"></div>
															
										<div class="d-flex col-md-6">
											<span class="p-1"></span>
											<Button class="p-button-sm" :disabled="!isValid" @click="update()" label="Save"/>
																
											<TheLoading v-if="isLoading"></TheLoading>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router"
	import store from "@/store";
	import settingApi from "@/api/setting-api";
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTabViewLoading from "@/components/TheTabViewLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	
	export default defineComponent({
		mixins: [dateUtilsMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTabViewLoading,
			TheLoading,
			ThePageError,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				settings: [] as any[],
				countries: [] as any[],
				countryStates: [] as any[],
				isPageLoading: false,
				isLoading: false,
				triggerLoading: null,
			}
		},
		computed: {
			isValid() {
				var settings = this.settings.filter((setting: any) => {
					if (setting.propertyName.indexOf('_M_') != -1 && !setting.propertyName.endsWith('_B') && (setting.propertyValue == null || setting.propertyValue === '')) {
						return setting;
					}
				});
				if (settings != null && settings.length > 0) {
					return false;
				}
				return true;
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				this.isPageLoading = true;
				
				let r2 = settingApi.settingList();
				
				Promise.all([r2])
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == 0) {
												this.settings = values[i].data.listSet;
											}
										}
									}
								}
							}
						}
						this.isPageLoading = false;
					})
					.catch(error => {
						this.pageError = error;
						this.isPageLoading = false;
					})
			}
		},
		methods: {
			update() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to proceed?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;
						
						if (this.settings != null && this.settings.length > 0) {
							for (var i = 0; i < this.settings.length; i++) {
								if (this.settings[i].propertyName.endsWith("_T") && !this.settings[i].isClosed) {
									if (this.settings[i].propertyValue != null && this.settings[i].propertyValue instanceof Date) {
										this.settings[i].propertyValue = this.formatToTime24Hour(this.settings[i].propertyValue);
									}
								}
							}
						}
				
						settingApi.settingUpdate({
								settings: this.settings
							})
							.then((response: any) => {
								this.isLoading = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
							})
							.catch(error => {
								this.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				});
			}
		},
	});
</script>
